import Location from './components/location';
import CurrentLocationDefault from './components/current-location';
import definition from './intl.json';
import intl from 'preact-i18n';

function intlWrap(Child) {
	return intl(Child, {
		scope: 'location-widget',
		definition
	});
}

export default intlWrap(Location);

export const CurrentLocation = intlWrap(CurrentLocationDefault);



// WEBPACK FOOTER //
// ../node_modules/@cube/location-widget/src/index.js